import React from 'react';
import { resolveTheme, panelStyle } from '../themes';
import type { Theme } from '../themes';

interface ErrorToastProps {
  theme?: string | Theme;
  message: string;
  onDismiss: () => void;
}

export function ErrorToast({ theme, message, onDismiss }: ErrorToastProps) {
  const T = resolveTheme(theme);
  return (
    <div
      role="alert"
      aria-live="assertive"
      style={panelStyle(T, {
        padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10,
        borderColor: '#ff6b6b',
      })}
    >
      <span style={{ color: '#ff6b6b', fontSize: 13, fontWeight: 600 }}>Error</span>
      <span style={{ color: T.text, fontSize: 12, flex: 1 }}>{message}</span>
      <button onClick={onDismiss} style={{
        appearance: 'none', border: 0, background: 'transparent',
        color: T.textDim, cursor: 'pointer', fontSize: 14,
      }}>x</button>
    </div>
  );
}
